angular.module('menuSearchBoxDirective', [])
    .directive('menuSearchBox', function () {

        return {
            scope: true,
            restrict: "E",
            templateUrl: "/Scripts/app/search-box/search-box.template.1.html",
            link: linkFunction,
            replace: true
        };

        function linkFunction(scope, elem, attr) {

            //INIT VARIABLES
            var model = JSON.parse(attr.data);
            var saytConfig =
            {
                subdomain: 'cineplex',
                collection: 'theatre', //Collection1 will appear first, then collection2, etc...
                collection2: 'store',
                saytCollection: 'theatreSayt',  //These collections are used for product recommendations
                saytCollection2: 'storeSayt',
                saytArea: model.saytArea,
                saytArea2: model.saytArea2,
                autocompleteTemplate: model.autocompleteTemplate,
                productTemplate: model.productTemplate,
                defaultImage: model.defaultImage,
                selectSearchTerm: function (data) {
                    searchInput.val(data.value);
                    searchForm.submit();
                },
                selectNavigation: function (data) {
                    searchInput.val(data.value);
                    searchForm.submit();
                },
                selectProduct: function (data) {
                    if (data.TheatreUrlName !== null && data.TheatreUrlName !== '')
                        window.location.href = model.showtimesUrl.replace('{0}', data.TheatreUrlName);
                    else if (data.TheatreUrl !== null && data.TheatreUrl !== '') {
                        if (data.LanguageField == 'lang_fr')
                            window.location.href = '/Film/' + data.TheatreUrl;
                        else
                            window.location.href = '/Movie/' + data.TheatreUrl;

                    }
                    else if (data.StoreUrlId !== null && data.StoreUrlId !== '')
                        window.location.href = model.storeUrl + data.StoreUrlId;
                }
            };
            var searchForm = elem.find(".search-form") || [];
            var searchInput = elem.find(".search-input") || [];
            var searchSubmit = elem.find(".search-go-btn") || [];
            var searchResultsContainer = "#ui-id-1.ui-autocomplete";

            //INIT SAYT
            searchInput.sayt(saytConfig);

            //SAYT results are fixed in window, hide until their position is updated
            $(window).on('resize', function () {
                hideSearchResults();
            });

            $(document).on("touchmove", function () {
                var st = window.pageYOffset || document.documentElement.scrollTop;
                if (st < 0) {
                    hideSearchResults();
                }
            });

            scope.searchBox = {};
            scope.searchBox.searchUrl = model.searchUrl;
            scope.searchBox.placeholder = model.searchPlaceholder;
            scope.searchBox.btn = model.searchBtnText;
            scope.searchBox.hasMobileToggle = model.hasMobileToggle != "true";
            scope.searchBox.isOpen = false;
            scope.searchBox.query = "";
            scope.searchBox.submitDisabled = true;

            scope.$watch(function (scope) { return scope.searchBox.query; }, function () {
                if (scope.searchBox.query === "")
                    scope.searchBox.submitDisabled = true;
                else {
                    scope.searchBox.submitDisabled = false;
                }
            });

            scope.searchBox.toggleOpen = function () {
                scope.searchBox.isOpen = !scope.searchBox.isOpen;
                if (scope.searchBox.isOpen) {
                    searchForm.show(function () {
                        searchInput.focus();
                        searchForm.one("blur", function (event) {
                            if (event.relatedTarget !== elem.find(".search-go-btn")[0])
                                scope.$apply(scope.searchBox.toggleOpen);
                            else;
                        });
                    });
                }
                else {
                    searchForm.hide();
                }
            };

            searchInput.keydown(function (e) {
                if (e.keyCode == 9) {
                    if (!e.shiftKey) {
                        var searchResults = $(searchResultsContainer).find('a');
                        if (searchResults.length > 0) {
                            $(searchResultsContainer).addClass('tab-focus');
                            searchResults[0].focus();
                            e.preventDefault();
                        }
                    }
                } else {
                    hideSearchResults();
                }
            });

            function hideSearchResults() {
                $(searchResultsContainer).removeClass('tab-focus').hide();
            }

            scope.$on('sideNavOpened', hideSearchResults);
            scope.$on('sideNavClosed', hideSearchResults);

            $(searchResultsContainer).keydown(function (e) {
                if (e.keyCode == 9) {
                    var currentSearchItem = $(e.target).closest('.ui-menu-item');
                    var searchResults = $(searchResultsContainer).find('.ui-menu-item');
                    if (e.shiftKey && currentSearchItem[0] == searchResults.first()[0]) {
                        searchInput.focus();
                        e.preventDefault();
                    } else if (currentSearchItem[0] == searchResults.last()[0]) {
                        searchSubmit.focus();
                        e.preventDefault();
                    }
                }
            });
        }

    });